export default __webpack_public_path__ + "static/media/sponsor_door.553a420a.png";